import { render, staticRenderFns } from "./EmployeeLeaves.vue?vue&type=template&id=a0ba8476&scoped=true"
import script from "./EmployeeLeaves.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaves.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLeaves.vue?vue&type=style&index=0&id=a0ba8476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ba8476",
  null
  
)

export default component.exports